// extracted by mini-css-extract-plugin
export var completionBody = "_kw-2";
export var completionCard = "_kw-0";
export var completionFooter = "_kw-3";
export var completionTitle = "_kw-1";